module.exports = __webpack_public_path__ + "static/media/agent.e60bd86e.png";